import { SupplierJoinForm } from "../components/contact/SupplierJoinForm";
import { Footer } from "../components/layout/Footer";
import { Header } from "../components/layout/Header";
import { PageMeta } from "../components/ui/PageMeta";

export function FaSupplierJoinPage() {
  return (
    <div className="fa-page">
      <PageMeta language="fa" title="معرفی شرکت و محصولات | IranTradeReach" description="فرم معرفی تولیدکنندگان و تأمین‌کنندگان ایرانی برای بررسی همکاری و توسعه بازار بین‌المللی با IranTradeReach." path="/fa/suppliers/join" />
      <a className="skip-link" href="#supplier-join-main">رفتن به فرم معرفی شرکت</a>
      <div className="inner-page-header"><Header /></div>
      <main id="supplier-join-main" className="fa-join-page">
        <header className="content-hero"><div className="container content-hero-inner"><div className="content-hero-copy"><p className="section-kicker">بررسی همکاری</p><h1>معرفی شرکت و محصولات</h1><p>اطلاعات زیر برای شناخت اولیه شرکت، محصولات و آمادگی حضور در بازارهای بین‌المللی استفاده می‌شود. ارسال فرم به معنی پذیرش قطعی یا تضمین فروش نیست.</p></div></div></header>
        <div className="container fa-join-layout"><div className="fa-join-intro"><h2>پیش از ارسال</h2><p>لطفاً اطلاعات واقعی و قابل پیگیری وارد کنید. تیم ما پس از بررسی اولیه، در صورت تناسب زمینه همکاری با شما تماس می‌گیرد.</p><ul><li>مشخصات محصولات اصلی را روشن بنویسید.</li><li>اطلاعات تماس مسئول پیگیری را وارد کنید.</li><li>از درج ادعاهای تأییدنشده خودداری کنید.</li></ul></div><SupplierJoinForm /></div>
      </main>
      <Footer />
    </div>
  );
}
